import { call, put, takeLatest } from "redux-saga/effects"
import { getSynchronizationsFailed, getSynchronizationsSuccess } from "./actions"
import { GET_SYNCHRONIZATIONS_WATCHER } from "./constants"
import axios from "axios"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"

export function getSynchronizationsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/synchronizations`,
  })
}


export function* getSynchronizationsSaga(action) {
  try {
    const { data, status } = yield call(
      getSynchronizationsApi,
    )
    
    if (status === 200) {
      yield put(getSynchronizationsSuccess(data.data))
    }
  } catch (e) {
    console.error(e)
    yield put(getSynchronizationsFailed())
  }
}

export default function* synchronizationSaga() {
  // See example in containers/HomePage/saga.js    
  yield takeLatest(GET_SYNCHRONIZATIONS_WATCHER, getSynchronizationsSaga)
}
  